<template>
  <div class="transaction-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title text-capitalize">Configurações &raquo; {{ termPlural }}</span>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-3">
          <b-col cols="12" class="mt-n3">
            <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
          </b-col>
        </b-row>
        <validation-observer ref="transactionForm" v-slot="{ invalid }">
          <b-row class="mb-3">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Informações d{{ letter }} {{ termSingular }}</p>
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col cols="12" md="4" >
                      <label class="cj-label">Nome da conta</label>
                      <validation-provider name="nome da conta" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="whatsappForm.name" :disabled="!((whatsappForm.id == null && canAdd) || (whatsappForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off" placeholder="Ex: Dr Paulo, Unid Centro, etc"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col cols="12" md="4" v-if="whatsappForm.number !== '' || whatsappForm.status != null">
                      <label class="cj-label">Número</label>
                      <b-form-input type="text" v-model="whatsappForm.number" :disabled="true" autocomplete="off" placeholder="Aguardando conexão..."></b-form-input>
                    </b-col>
                    <b-col cols="12" md="4" v-if="whatsappForm.status != null">
                      <label class="cj-label">Status</label>
                      <div class="whatsapp-status"><i class="fa fa-circle mr-2" :class="'status-indicator ' + getStatus().class"></i>{{getStatus().name}}</div>
                    </b-col>
                  </b-row>

<!--                  TODO mostrar novamente depois, se resolverem cobrar algo-->
                  <b-row v-if="false && whatsappForm.id == null" class="mt-3 mb-2">
                    <b-col>
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="whatsappForm.accepted_terms" />
                        <div class="state p-success">
                          <label><span>Estou ciente e de acordo que ao cadastrar uma nova instância será adicionado o valor de R$24,90 (por conta de Whatsapp) na minha assinatura. *</span></label>
                        </div>
                      </div>
                      <div>
                        <label class="cj-label"><span>* Consulte condições para 5 números ou mais.</span></label>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row v-if="whatsappForm.qrcode != null" class="mb-2 text-center">
                    <b-col cols="12">
                      <p class="mt-1 mb-0">Abra o aplicativo do Whatsapp e leia o QRCode abaixo para conectar seu número.</p>
                    </b-col>
                    <b-col cols="12">
                      <img :src="whatsappForm.qrcode" alt="QRCode" />
                    </b-col>
                  </b-row>

                  <hr class="mb-3">
                  <b-row class="mb-2">
                    <b-col class="d-flex align-items-end">
                      <label class="cj-label"><span>Em caso de desconexão do número, para que a entrega de mensagens não seja prejudicada, enviaremos uma mensagem de alerta no Whatsapp do número informado.</span></label>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Número de contato para alertas</label>
                      <validation-provider name="número de contato para alertas" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="whatsappForm.status_notification_cellphone" v-mask="'(##) #####-####'" :disabled="!((whatsappForm.id == null && canAdd) || (whatsappForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer clearfix" v-if="((whatsappForm.id == null && canAdd) || (whatsappForm.id != null && canEdit) || canRemove)">
                  <b-button variant="primary" class="mr-3" :disabled="!canPerformAction || !((whatsappForm.id == null && canAdd && whatsappForm.accepted_terms) || (whatsappForm.id != null && canEdit))" @click="saveWhatsapp">Salvar</b-button>
                  <b-button variant="danger" class="mr-3" v-if="whatsappForm.id != null && canRemove" @click="deleteWhatsapp">Excluir</b-button>
                  <b-button variant="danger" class="float-right" v-if="whatsappForm.id != null && whatsappForm.status != null && whatsappForm.status !== 'connecting' && whatsappForm.status !== 'disconnected' && canRemove" @click="disconnectWhatsapp">Desconectar</b-button>
<!--                  <b-button variant="warning" class="mr-3 float-right" v-if="whatsappForm.id != null && whatsappForm.status != null && whatsappForm.status !== 'connecting' && whatsappForm.status !== 'disconnected' && canRemove" @click="rebootWhatsapp">Reiniciar</b-button>-->
                </div>
              </div>
            </b-col>
          </b-row>
        </validation-observer>
      </div>
    </b-container>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        leavingPage: false,
        user: null,

        termSingular: 'conta de Whatsapp',
        termPlural: 'contas de Whatsapp',
        url: 'configuracoes/contas-de-whatsapp',
        letter: 'a',
        newTerm: 'cadastrar-conta-de-whatsapp',
        module: 'whatsapps',

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        interval: null,

        whatsappForm: {
          id: null,
          name: '',
          status_notification_cellphone: '',
          number: '',
          whatsapp_id: null,
          qrcode: null,
          status: null,
          accepted_terms: true, //TODO mudar isso se voltar a usar a confirmacao
        }
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      this.canSee = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'COORDINATOR')?true:this.helpers.checkPermission(this.module, 'can_manage');

      if(this.canSee == false || (this.user.person.client.mandic_campaign && this.user.person.client.mandic_campaign.trial_active === 0 && this.user.person.client.mandic_campaign.subscription_active === 0)) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;
      if(this.$route.params.id != this.newTerm) {
        await this.api.getWhatsapp(this.$route.params.id).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          this.whatsappForm = {
            id: res.data.item.id,
            name: res.data.item.name,
            status_notification_cellphone: res.data.item.status_notification_cellphone,
            number: res.data.item.number,
            whatsapp_id: null,
            qrcode: null,
            status: null,
          };
          if(res.data.status.id) {
            this.whatsappForm.whatsapp_id = res.data.status.id;
          }
          if(res.data.status.instance && res.data.status.instance.qrcode) {
            this.whatsappForm.qrcode = res.data.status.instance.qrcode;
          }
          if(res.data.status.instance && res.data.status.instance.status) {
            this.whatsappForm.status = res.data.status.instance.status;
            if(this.whatsappForm.status !== 'connected') {
              this.interval = setInterval(this.checkStatus, 10*1000);
            }
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Whatsapp', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.$router.push({path: '/' + this.url}).catch(() => {});

          this.$swal('Ops...', 'Não conseguimos carregar esta ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Whatsapp', err.response);
        });
      } else {
        this.eventBus.$emit('IS_LOADING', false);
        this.canPerformAction = true;
      }
    },
    methods: {
      async saveWhatsapp() {
        if(!this.canPerformAction || !((this.whatsappForm.id == null && this.canAdd) || (this.whatsappForm.id != null && this.canEdit)))
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.transactionForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let whatsappData = {
          id: this.whatsappForm.id,
          name: this.whatsappForm.name,
          status_notification_cellphone: this.whatsappForm.status_notification_cellphone
        };

        this.eventBus.$emit('IS_LOADING', true);
        if (this.whatsappForm.id == null) {
          this.api.storeWhatsapp(whatsappData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 201) {
              this.$router.push({path: '/'+this.url+'/'+res.data.id}).catch(() => {});

            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao criar a '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Whatsapp', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos criar esta '+this.termSingular+'! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Whatsapp', err.response);
          });
        } else {
          this.api.updateWhatsapp(this.whatsappForm.id, whatsappData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 200) {
              this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi atualizada com sucesso!', 'success').then(() => {
                this.$router.push({path: '/' + this.url}).catch(() => {});
              });
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Whatsapp', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos atualizar esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Whatsapp', err.response);
          });
        }
      },

      async checkStatus() {
        this.api.checkWhatsappStatus(this.whatsappForm.id, {whatsapp_id: this.whatsappForm.whatsapp_id}).then(res => {
          if(this.leavingPage) {
            return;
          }
          if (res.status == 200) {
            this.whatsappForm.status = res.data.instance.status;

            if(res.data.number) {
              this.whatsappForm.number = res.data.number;
            }
            if(res.data.instance.status == 'connected') {
              this.whatsappForm.qrcode = null;
              this.clearTimer();
              this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi conectada com sucesso!', 'success');
            }
            else {
              this.whatsappForm.qrcode = res.data.instance.qrcode;
              if(res.data.id) {
                this.whatsappForm.whatsapp_id = res.data.id;
              }
            }
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Check Status', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$swal('Ops...', 'Não conseguimos verificar o status desta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Check Status', err.response);
        });
      },

      async deleteWhatsapp() {
        if(this.canRemove) {
          let doCancel = false;

          await this.$swal({
            title: 'Você tem certeza?',
            text: 'Esta ação não poderá ser desfeita!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              doCancel = true;
            }
          });

          if(doCancel) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);
            this.clearTimer();
            this.api.deleteWhatsapp(this.whatsappForm.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi excluída com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/' + this.url}).catch(() => {});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao excluir a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Whatsapp', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos excluir esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Whatsapp', err.response);
            });
          }
        }
      },

      async disconnectWhatsapp() {
        if(this.canRemove) {
          let doCancel = false;

          await this.$swal({
            title: 'Você tem certeza?',
            text: 'Esta ação não poderá ser desfeita!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              doCancel = true;
            }
          });

          if(doCancel) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);
            this.api.disconnectWhatsapp(this.whatsappForm.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi desconectada com sucesso!', 'success').then(() => {
                  this.$router.go();
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao desconectar a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Disconnect Whatsapp', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos desconectar esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Disconnect Whatsapp', err.response);
            });
          }
        }
      },

      // async rebootWhatsapp() {
      //   if(this.canRemove) {
      //     let doCancel = false;
      //
      //     await this.$swal({
      //       title: 'Você tem certeza?',
      //       text: 'Esta ação não poderá ser desfeita!',
      //       type: 'warning',
      //       showCancelButton: true,
      //       confirmButtonText: 'OK',
      //       cancelButtonText: 'Cancelar',
      //       focusCancel: true
      //     }).then((res) => {
      //       if(res.value) {
      //         doCancel = true;
      //       }
      //     });
      //
      //     if(doCancel) {
      //       this.canPerformAction = false;
      //       this.eventBus.$emit('IS_LOADING', true);
      //       this.api.rebootWhatsapp(this.whatsappForm.id).then(res => {
      //         this.eventBus.$emit('IS_LOADING', false);
      //         this.canPerformAction = true;
      //         if (res.status == 204) {
      //           this.$swal('Uhull \\o/', 'A ' + this.termSingular + ' foi reiniciada com sucesso!', 'success').then(() => {
      //             this.$router.go();
      //           });
      //         } else {
      //           this.$swal('Ops...', 'Ocorreu um erro ao reiniciar a ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
      //         }
      //
      //         if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //           console.log('Response Reboot Whatsapp', res);
      //       }).catch(err => {
      //         this.eventBus.$emit('IS_LOADING', false);
      //         this.canPerformAction = true;
      //         this.$swal('Ops...', 'Não conseguimos reiniciar esta ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
      //         if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
      //           console.log('Error Reboot Whatsapp', err.response);
      //       });
      //     }
      //   }
      // },

      getStatus() {
        if(this.whatsappForm.status == 'connected') {
          return {name:'Conectado!', class: 'enabled'};
        }
        else if(this.whatsappForm.status == 'connecting') {
          return {name:'Aguardando leitura do QRCode/Conectando', class: 'pending'};
        }
        else if(this.whatsappForm.status == 'disconnected') {
          return {name:'Desconectado', class: 'deleted'};
        }
        // else if(whatsapp.status == 'deleted') {
        //   return {name:'Excluído', class: 'deleted'};
        // }
        // else {
        //   return {name:'Desabilitado', class: 'disabled'};
        // }
      },

      goBack() {
        this.$router.push({path: '/' + this.url}).catch(() => {});
      },

      clearTimer() {
        if(this.interval != null) {
          clearInterval(this.interval);
          this.interval = null;
        }
      }
    },
    beforeRouteLeave (to, from, next) {
      this.clearTimer();
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .transaction-form {
    padding: 20px 0;

    .text1 {
      font-size: 14px;
      color: $cadetGray;
      margin-bottom: 0;
    }

    .whatsapp-status {
      .status-indicator {
        font-size: 14px;

        &.enabled {
          color: $ufoGreen;
        }
        &.pending {
          color: $yellowSea;
        }
        &.deleted {
          color: $dullRed;
        }
        &.disabled {
          color: #333333;
        }
      }
    }

  }
</style>
